import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useMemo } from 'react'
import { ClientBookingReservationService } from '../services/client_booking_reservation.service'
import { BookingReservationClientDto, CreateBookingOrderClientInput } from '../types'
import { defaultQueryOptions } from './common'

export const useClientBookingReservation = (
  locationName: string,
  bookingOrder?: CreateBookingOrderClientInput
): UseQueryResult<BookingReservationClientDto | null> => {
  const bookingOrderKey = useMemo(() => (bookingOrder ? JSON.stringify(bookingOrder) : null), [bookingOrder])
  return useQuery<BookingReservationClientDto | null>({
    queryKey: ['clientBookingReservation', locationName, bookingOrderKey],
    queryFn: () => ClientBookingReservationService.makeReservation(locationName, bookingOrder!),
    enabled: Boolean(bookingOrder),
    ...defaultQueryOptions,
  })
}
